import type { Translations } from '../../../types'

const shopFeaturedImageMessages: Translations = {
  "shop.featuredImage.title": "Foto prodotto",
  "shop.featuredImage.previewAlt": "Immagine in evidenza",
  "shop.featuredImage.dropzone.empty": "Trascina una o piu immagini qui oppure usa i pulsanti sotto.",
  "shop.featuredImage.dropzone.helper": "Supporta drag and drop multiplo. La foto principale viene usata come hero del prodotto.",
  "shop.featuredImage.galleryLabel": "Gallery ({{count}})",
  "shop.featuredImage.galleryEmpty": "Nessuna foto aggiunta.",
  "shop.featuredImage.galleryItemAlt": "Foto prodotto",
  "shop.featuredImage.mediaLibrary.description": "Clicca una o piu immagini per aggiungerle alla gallery prodotto.",
  "shop.featuredImage.actions.upload": "Carica foto",
  "shop.featuredImage.actions.uploading": "Upload...",
  "shop.featuredImage.actions.fromMediaLibrary": "Aggiungi da Media Library",
  "shop.featuredImage.actions.clearAll": "Rimuovi tutte",
  "shop.featuredImage.actions.isFeatured": "Principale",
  "shop.featuredImage.actions.makeFeatured": "Rendi principale",
  "shop.featuredImage.actions.remove": "Rimuovi",
}

export default shopFeaturedImageMessages
